import { ReferenceField } from "@/components/admin";
import type { Identifier } from "ra-core";
import { useGetRecordRepresentation, useTranslate } from "ra-core";
import { EditSheet } from "../misc/EditSheet";
import { TaskFormContent } from "./TaskFormContent";
import { applyTaskStatusChange } from "./taskStatuses";

export interface TaskEditSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  taskId: Identifier;
}

export const TaskEditSheet = ({
  open,
  onOpenChange,
  taskId,
}: TaskEditSheetProps) => {
  const translate = useTranslate();
  const getContactRepresentation = useGetRecordRepresentation("contacts");
  const defaultTitle = (
    <span className="text-xl font-semibold truncate pr-10">
      {translate("resources.tasks.sheet.edit")}
    </span>
  );
  return (
    <EditSheet
      resource="tasks"
      id={taskId}
      title={
        <ReferenceField
          source="contact_id"
          reference="contacts"
          empty={defaultTitle}
          render={({ referenceRecord }) =>
            referenceRecord ? (
              <span className="text-xl font-semibold truncate pr-10">
                {translate("resources.tasks.sheet.edit_for", {
                  name: getContactRepresentation(referenceRecord),
                })}
              </span>
            ) : (
              defaultTitle
            )
          }
        />
      }
      redirect={false}
      open={open}
      onOpenChange={onOpenChange}
      transform={(data, options) =>
        applyTaskStatusChange(data, options?.previousData)
      }
    >
      <TaskFormContent />
    </EditSheet>
  );
};
